import { render, staticRenderFns } from "./Webcomponent.vue?vue&type=template&id=5fd5c46c&scoped=true"
import script from "./Webcomponent.vue?vue&type=script&lang=js"
export * from "./Webcomponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd5c46c",
  null
  
)

export default component.exports